interface ErrorAlertProps {
  message: string
  onRetry?: () => void
}

export default function ErrorAlert({ message, onRetry }: ErrorAlertProps) {
  return (
    <div className="rounded-card border border-danger-border bg-danger-light p-4">
      <div className="flex items-start gap-3">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mt-0.5 shrink-0 text-danger">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        <div className="flex-1">
          <p className="text-sm font-semibold text-danger">Error</p>
          <p className="mt-0.5 text-sm text-danger">{message}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="mt-3 rounded-input bg-danger-light border border-danger-border px-3 py-1.5 text-sm font-medium text-danger hover:bg-danger hover:text-white transition-colors focus:outline-none"
            >
              Reintentar
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
